<template>

</template>

<script>
export default {
    name: "Forgotten"
}
</script>

<style scoped>

</style>
